const  projectsNode = [
    {
       proTitle: "Node projects", 
       projectProps: [
        {
            title: "yt-v-props-getter",
            img: "./img_projects/Node/project1.png",
            desc: "Receives information relating to the video based on the URL passed.",
            long_desc: `Based on the URL passed, it receives information relating to a specific video file.
            <p>Capture information related to playlists, the playlist with a number of elements greater than one hundred will be evaluated up to the hundredth element.</p>`,
            topics: "Node, ES6, Express, axios, ASYNC/AWAIT, JSON",
            location_url: "https://node-yt-video-props-getter.onrender.com",
            source_code: false
        },
        // {
            //     title: "PHP OOP file downloader",
            //     img: "./img_projects/php/project3.png",
            //     desc: "OOP PHP file download.",
            //     long_desc: `Shows how to download a file via PHP/OOP in four different ways.`,
            //     topics: "PHP, OOP",
            //     location_url: "https://github.com/pippo-github/php_downloader_4_ways",
            //     // location_url: "./web_app/projects/php/php_downloader/index.php", mettere il link a github non permette la creazione di file aruba.it
            //     source_code: true
            // },
        ]
    }
]

export {projectsNode}
